import {
    PROMO_TYPOLOGY_CREDIT_CARD,
    PROMO_TYPOLOGY_SHORT_TERM,
    PROMO_TYPOLOGY_SUBSCRIPTION
} from "../../../component/Constants";
import {Grid, TextField} from "@mui/material";
import dayjs from "dayjs";
import * as React from "react";
import {Controller} from "react-hook-form";
import {DatePicker} from "@mui/x-date-pickers";
import {useTranslation} from "react-i18next";
import {ProductAndDateRowsProps} from "../Constants/PromoInterfaces";

const ProductAndDateRows = ({watch, selectedProduct, control, setValue, disabledConfirm } : ProductAndDateRowsProps ) => {
    const {t} = useTranslation(['salesmarketing', 'translation']);
    return (
        <>
            {(watch('typology') !== PROMO_TYPOLOGY_CREDIT_CARD) &&
                <>
                    < Grid item xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            label={t('promo.selectedProductName')}
                            value={selectedProduct.name ? selectedProduct.name : ""}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            label={t('promo.selectedProductDescription')}
                            value={selectedProduct.description ? selectedProduct.description : ""}
                        />
                    </Grid>
                </>
            }
            {(watch('typology')=== PROMO_TYPOLOGY_SHORT_TERM) &&
                <>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            label={t('promo.selectedProductStartDate')}
                            value={selectedProduct.startDate ? dayjs(selectedProduct.startDate).format("L") : ""}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            label={t('promo.selectedProductEndDate')}
                            value={selectedProduct.endDate ? dayjs(selectedProduct.endDate).format("L") : ""}
                        />
                    </Grid>
                </>
            }
            {watch('typology') !==PROMO_TYPOLOGY_SUBSCRIPTION ? (
            <>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name="bookingStartDate"
                        render={({field, fieldState}) => (
                            <DatePicker
                                label={t('promo.bookingStartDate')}
                                value={field.value}
                                onChange={(e) => {
                                    setValue!("bookingStartDate", dayjs(e).startOf("day").toDate())
                                }}
                                minDate={disabledConfirm ? null : selectedProduct.startDate ? selectedProduct.startDate : null}
                                maxDate={watch("bookingEndDate") ? watch("bookingEndDate") : null}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required
                                        fullWidth
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />}
                                inputFormat={"L"}
                            />
                        )}/>
                </Grid>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name="bookingEndDate"
                        render={({field, fieldState}) => (
                            <DatePicker
                                label={t('promo.bookingEndDate')}
                                value={field.value}
                                onChange={(e) => {
                                    setValue!("bookingEndDate", dayjs(e).startOf("day").toDate())
                                }}
                                minDate={watch("bookingStartDate") ? watch("bookingStartDate") : null}
                                maxDate={disabledConfirm ? null : selectedProduct.endDate ? selectedProduct.endDate : null}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required
                                        fullWidth
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />}
                                inputFormat={"L"}
                            />
                        )}/>
                </Grid>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name="pickupStartDate"
                        render={({field, fieldState}) => (
                            <DatePicker
                                label={t('promo.pickupStartDate')}
                                value={field.value}
                                onChange={(e: any) => {
                                    setValue!("pickupStartDate", dayjs(e).startOf("day").toDate())
                                }}
                                maxDate={watch("pickupEndDate") ? watch("pickupEndDate") : null}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required
                                        fullWidth
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />}
                                inputFormat={"L"}
                            />
                        )}/>
                </Grid>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name="pickupEndDate"
                        render={({field, fieldState}) => (
                            <DatePicker
                                label={t('promo.pickupEndDate')}
                                value={field.value}
                                onChange={(e: any) => {
                                    setValue!("pickupEndDate", dayjs(e).startOf("day").toDate())
                                }}
                                minDate={watch("pickupStartDate") ? watch("pickupStartDate") : null}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required
                                        fullWidth
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />}
                                inputFormat={"L"}
                            />
                        )}/>
                </Grid>
            </>) :(<Grid item xs={6}/>)
            }
        </>
    );
}

export default ProductAndDateRows;